import { getAuth, signOut } from "firebase/auth";
import Cookies from "js-cookie";

const LogoutAuth = async (navigate, navPath) => {
  const auth = getAuth();

  await signOut(auth)
    .then(() => {
      ["userName", "userEmail", "profImg", "newUser"].forEach((k) =>
        localStorage.removeItem(k),
      );
      Cookies.remove("token");
      Cookies.remove("userId");

      if (navigate !== undefined && navPath !== undefined) {
        navigate(navPath, { replace: true });
      }
    })
    .catch((error) => {
        console.error("Logout failed", error);
        throw error; 
    });
};

export default LogoutAuth;
